import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";

import Layouts from "../../layouts/layouts";
import Breadcrumb from "../../components/breadcrumb/index";
import DataTable from "react-data-table-component";
export default function MaintenanceHistory() {
  const { id } = useParams();

  const [historyData, setHistoryData] = useState([]);
  const [loading, setLoading] = useState(true);

  const title = "Vehicle Maintenance History";

  const brad = [
    {
      name: "Home",
    },
    {
      name: "Vehicle Maintenance",
    },
    {
      name: title,
    },
  ];

  const formatDate = (dateString) => {
    if (!dateString) return "-";

    const date = new Date(dateString);

    if (isNaN(date.getTime())) return "-";

    return date.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });
  };

  const fetchHistory = async () => {
    try {
      setLoading(true);

      const token = localStorage.getItem("token");

      if (!token) {
        console.error("No token found");
        return;
      }

      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/api/v4/maintenance-history/${id}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );

      if (response.data.success) {
        setHistoryData(response.data.data || []);
      } else {
        setHistoryData([]);
      }
    } catch (error) {
      console.error("Error fetching maintenance history:", error);
      setHistoryData([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (id) {
      fetchHistory();
    }
  }, [id]);

  const columns = [
    {
      name: <b>Vehicle</b>,
      selector: (row) => (row.vehicle ? row.vehicle.numberplate : "-"),
      sortable: true,
    },
    {
      name: <b>Completed On</b>,
      selector: (row) => formatDate(row.createdAt),
      sortable: true,
    },

    {
      name: <b>Service Type</b>,
      selector: (row) => row.serviceType || "-",
      sortable: true,
    },

    {
      name: <b>Done Service Date</b>,
      selector: (row) => formatDate(row.lastServiceDate),
      sortable: true,
    },

    {
      name: <b>Done Service Km</b>,
      selector: (row) => Math.round(row.lastServiceKm || 0),
      sortable: true,
    },

    {
      name: <b>Amount Paid </b>,
      selector: (row) =>
        row.amount !== undefined && row.amount !== null ? row.amount : 0,
      sortable: true,
    },

    {
      name: <b>Status</b>,
      selector: (row) => row.status || "-",
      sortable: true,
    },

    {
      name: <b>Notes</b>,
      selector: (row) => row.notes || "-",
      sortable: true,
    },
  ];

  return (
    <>
      <Layouts />

      <div className="container-fluid">
        <div className="row my-3">
          <div className="col-12">
            <div
              className="card"
              style={{
                borderTop: "2px solid #4723d9",
              }}
            >
              <div className="card-header d-flex justify-content-between border-bottom pb-1">
                <h4>{title}</h4>
              </div>

              <div className="card-body">
                {loading ? (
                  <p>Loading...</p>
                ) : historyData.length > 0 ? (
                  <DataTable
                    columns={columns}
                    data={historyData}
                    pagination
                    fixedHeader
                    highlightOnHover
                    responsive
                    paginationPerPage={5}
                    paginationRowsPerPageOptions={[5, 10, 15, 20]}
                  />
                ) : (
                  <p>No maintenance history found.</p>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
